<benefits-dialog [open]="true" [heading]="'ASSET_CHARGES.PURCHASE_TITLE' | translate" [eyebrow]="'ASSET_CHARGES.TITLE' | translate" (closed)="closed.emit()">
  <div class="purchase-charge-dialog">
    <!-- WN-1509: the static `field--required` class draws the shared red asterisk (styles.scss). -->
    <div class="field field--required">
      <span class="field__label">{{ 'ASSET_CHARGES.EMPLOYEE' | translate }}</span>
      <app-user-lookup-select
        aria-required="true"
        [value]="userId()"
        (valueChange)="setUser($event)"
        [placeholder]="'ASSET_CHARGES.SELECT_EMPLOYEE' | translate"
        [loadingLabel]="'ASSET_CHARGES.LOADING_EMPLOYEES' | translate"
        [emptyLabel]="'ASSET_CHARGES.NO_EMPLOYEE_MATCHES' | translate"
        [clearLabel]="'ASSET_CHARGES.CLEAR_EMPLOYEE' | translate"
      />
    </div>

    <label class="field field--required" for="purchase-charge-item">
      <span class="field__label">{{ 'ASSET_CHARGES.ITEM' | translate }}</span>
      <input id="purchase-charge-item" class="field__input" type="text" aria-required="true" [value]="item()" (input)="item.set($any($event.target).value)" />
    </label>

    <div class="field">
      <span class="field__label">{{ 'ASSET_CHARGES.ASSET_OPTIONAL' | translate }}</span>
      <app-asset-select [allowNone]="true" (picked)="assetId.set($event)" />
    </div>

    <label class="field field--required" for="purchase-charge-amount">
      <span class="field__label">{{ 'ASSET_CHARGES.AMOUNT' | translate }}</span>
      <input id="purchase-charge-amount" class="field__input" type="number" min="0" step="0.01" inputmode="decimal" aria-required="true" [value]="amountText()" (input)="setAmount($any($event.target).value)" />
    </label>

    <div class="field" role="radiogroup" [attr.aria-label]="'ASSETS.CHARGE.PAYMENT' | translate">
      <span class="field__label">{{ 'ASSETS.CHARGE.PAYMENT' | translate }}</span>
      <label class="purchase-charge-dialog__radio" for="purchase-charge-pay-full">
        <input id="purchase-charge-pay-full" type="radio" name="purchase-charge-payment" [checked]="payment() === 'full'" (change)="setPayment('full')" />
        <span>{{ 'ASSETS.CHARGE.FULL' | translate }}</span>
      </label>
      <label class="purchase-charge-dialog__radio" for="purchase-charge-pay-installments">
        <input id="purchase-charge-pay-installments" type="radio" name="purchase-charge-payment" [checked]="payment() === 'installments'" (change)="setPayment('installments')" />
        <span>{{ 'ASSETS.CHARGE.INSTALLMENTS' | translate }}</span>
      </label>
    </div>

    @if (payment() === 'installments') {
      <label class="field field--required" for="purchase-charge-count">
        <span class="field__label">{{ 'ASSETS.CHARGE.COUNT' | translate }}</span>
        <input id="purchase-charge-count" class="field__input" type="number" min="2" step="1" inputmode="numeric" aria-required="true" [value]="countText()" (input)="setCount($any($event.target).value)" />
      </label>
    }

    <label class="field field--required" for="purchase-charge-start">
      <span class="field__label">{{ 'ASSETS.CHARGE.START' | translate }}</span>
      <input id="purchase-charge-start" class="field__input" type="month" aria-required="true" [attr.aria-invalid]="startInvalid() ? 'true' : null" [attr.aria-describedby]="startInvalid() ? 'purchase-charge-start-error' : null" [value]="start()" (input)="setStart($any($event.target).value)" (blur)="startTouched.set(true)" />
      @if (startInvalid()) {
        <span class="field__error" id="purchase-charge-start-error" role="alert">{{ 'ASSET_CHARGES.START_REQUIRED' | translate }}</span>
      }
    </label>

    <label class="field" for="purchase-charge-note">
      <span class="field__label">{{ 'ASSETS.CHARGE.NOTE' | translate }}</span>
      <input id="purchase-charge-note" class="field__input" type="text" [value]="note()" (input)="note.set($any($event.target).value)" />
    </label>

    <app-asset-charge-preview [preview]="preview()" />

    @if (error(); as err) {
      <p class="wn-banner wn-banner--error purchase-charge-dialog__error" role="alert">{{ err }}</p>
    }
  </div>

  <ng-container benefitsDialogFooter>
    <button type="button" pButton [outlined]="true" [label]="'COMMON.CANCEL' | translate" (click)="closed.emit()"></button>
    <button type="button" pButton class="purchase-charge-dialog__confirm" icon="pi pi-check" [label]="'COMMON.CONFIRM' | translate" [disabled]="!valid() || saving()" (click)="confirm()"></button>
  </ng-container>
</benefits-dialog>
